import(/* webpackMode: "eager" */ "/usr/src/app/app/[locale]/auth/login/page.tsx");
